var _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "id_svgCanvas",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5772181573_SVGID_1__focus",
    d: "M60,47c0,1.657-1.343,3-3,3H7c-1.657,0-3-1.343-3-3V17c0-1.657,1.343-3,3-3h50c1.657,0,3,1.343,3,3V47z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181573_SVGID_1__focus",
    className: "stshockcolor",
    style: {
      fill: "rgb(217, 154, 87)",
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5772181573_SVGID_2__focus"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181573_SVGID_1__focus",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1",
    style: {
      clipPath: "url(#5772181573_SVGID_2__focus)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "4,50 57.688,50 4,19   ",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "5772181573_SVGID_3__focus",
    x: 4,
    y: 19,
    width: 56,
    height: 10
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181573_SVGID_3__focus",
    style: {
      overflow: "visible",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5772181573_SVGID_4__focus"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181573_SVGID_3__focus",
    style: {
      overflow: "visible",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2",
    style: {
      clipPath: "url(#5772181573_SVGID_4__focus)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "54.227,29 21.319,29 27.092,19 60,19     ",
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    }
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 33,
    className: "st0",
    width: 36,
    height: 4,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    className: "st0",
    width: 26,
    height: 4,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/default-card.66823b043914f27c6bb61d60039d27c9.svg";
export { ForwardRef as ReactComponent };